import { gql } from '__generated__';

export default gql(`
  query GetRegistration($id: ID!) {
    registration(id: $id) {
      ...BackendRegistrationFields
    }
  }
`);
